<template>
	<div class="content-popular-provider__container">
		<div>
			<div class="content-popular-provider__row container-fluid container-max-width filter-bar">
				<LazyFilterBarPopularProvider
					:collectionType="collectionType"
					:newPageType="newPageType"
					:currentFilters="currentFilters"
					:userProviders="userProviders"
				/>
			</div>

			<div class="content-popular-provider__row container-fluid container-max-width filter-bar">
				<LazyFilterBarContentTypeSeo
					:collectionType="collectionType"
					:currentFilters="currentFilters"
					:showCatalogTab="currentFilters.providers.length === 1"
					:allTitle="provider.clearName"
				/>
			</div>
		</div>
		<div class="content-popular-provider__row container-fluid container-max-width titles">
			<Top10Titles :selectedTab="selectedTab" :provider="provider" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';

import { CollectionType } from '@/enums/collection-type';

import Provider from '@/interfaces/provider';
import { PopularTabType } from '@/interfaces/titles';

import type { FilterCollection } from '@/stores/useFilterStoreTypes';

import Top10Titles from './Top10Titles.vue';
const LazyFilterBarPopularProvider = defineLazyHydrationComponent(
	'idle',
	() => import('./FilterBarPopularProvider.vue')
);
const LazyFilterBarContentTypeSeo = defineLazyHydrationComponent(
	'idle',
	() => import('@/components/filter-bar/seo/FilterBarContentTypeSeo.vue')
);

import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { storeToRefs } from 'pinia';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

withDefaults(
	defineProps<{
		collectionType: CollectionType;
		currentFilters: FilterCollection;
		providersInMenu?: boolean;
		provider: Provider;
		selectedTab: PopularTabType;
		amount: number;
	}>(),
	{
		providersInMenu: false,
	}
);

const emit = defineEmits<{ (e: 'done'): void }>();

onMounted(() => emit('done'));

const { providers } = useConstantStore();
const userProviders = computed(() => providers());

const { activeRoute } = storeToRefs(useRoutingStore());
const newPageType = computed(() => activeRoute?.value?.meta?.newPageType);
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.content-popular-provider {
	&__container {
		:deep(.sub-heading) {
			font-size: 32px;
			color: #fff;
			font-weight: 900;
			line-height: 32px;
			letter-spacing: 0.22px;
		}
	}

	&__row {
		@include sm() {
			margin-bottom: 24px;
		}

		&.no-margin {
			margin-bottom: 0px;
		}

		&.no-padding {
			padding: 0px;
		}

		&.filter-bar {
			margin-bottom: 5px;
		}

		@media (max-width: 1050px) {
			padding: 0 15px !important;
			&.no-padding-sm {
				padding: 0px;
			}
		}
	}
}
</style>
